import { AnalyticsPlugin } from 'analytics';

import { TrackingPixelVendor } from '../enums/TrackingPixelVendor';
import { createTrackingPixelPlugin } from '../functions/createTrackingPixelPlugin';
import { getPlaceholderValues } from '../functions/getPlaceholderValues';
import { interpolateUrl } from '../functions/interpolateUrl';

export const iframePlugin = (): AnalyticsPlugin =>
  createTrackingPixelPlugin(
    TrackingPixelVendor.IFRAME,
    (pixels, { properties }): void => {
      const values = getPlaceholderValues(properties);

      pixels.forEach(({ url }): void => {
        if (!url) {
          return;
        }

        const iframe = document.createElement('iframe');

        iframe.height = '0';
        iframe.src = interpolateUrl(url, values);
        iframe.style.display = 'none';
        iframe.tabIndex = -1;
        iframe.width = '0';
        iframe.setAttribute('aria-hidden', 'true');

        // left in place so the vendor's redirect chain can finish
        document.body.appendChild(iframe);
      });
    },
  );
